module.exports = __webpack_public_path__ + "img/840.39e0952c.svg";